
import { IAPICrossMatchSummaryStats } from "@app/dashboard/interfaces/api-crossmatch-summary-stats.interface";

export class CrossMatchSummaryStatsModel {
    public dataSourceCode: string;
    public relatedDataSourceCode: string;
    public dataSourceId: number;
    public relatedDataSourceId: number;
    public disclosedRecordCount: number;
    public possibleMatchesCount: number;
    public matchCount: number;
    public ambiguousCount: number;
    public possibleRelationshipsCount: number;
    
    constructor(data?: Partial<CrossMatchSummaryStatsModel>) {
        this.dataSourceCode = data && data.dataSourceCode || '';
        this.relatedDataSourceCode = data && data.relatedDataSourceCode || '';
        this.dataSourceId = data && data.dataSourceId || 0;
        this.relatedDataSourceId = data && data.relatedDataSourceId || 0;
        
        this.disclosedRecordCount = data && data.disclosedRecordCount || 0;
        this.possibleMatchesCount = data && data.possibleMatchesCount || 0;
        this.matchCount = data && data.matchCount || 0;
        this.ambiguousCount = data && data.ambiguousCount || 0;
        this.possibleRelationshipsCount = data && data.possibleRelationshipsCount || 0;
    }


    static Deserialize(api: IAPICrossMatchSummaryStats): CrossMatchSummaryStatsModel {
        const data: CrossMatchSummaryStatsModel = {
            dataSourceCode: api.dataSourceCode,
            relatedDataSourceCode: api.relatedDataSourceCode,
            dataSourceId: api.dataSourceId,
            relatedDataSourceId: api.relatedDataSourceId,
            ambiguousCount: api.ambiguousCount,
            disclosedRecordCount: api.disclosedCount,
            possibleMatchesCount: api.possibleMatchCount,
            // todo: fix API response. one letter difference
            possibleRelationshipsCount: api.possibleRelationshipCount,
            matchCount: api.matchCount,
        };

        return new CrossMatchSummaryStatsModel(data);
    }

    static DeserializeList(api: IAPICrossMatchSummaryStats[]): CrossMatchSummaryStatsModel[] {
        if (!Array.isArray(api)) {
            return [];
        }

        return api.map(a => CrossMatchSummaryStatsModel.Deserialize(a));
    }
}